import { Box, Drawer, IconButton, Stack } from "@mui/material";
import { Menu as MenuIcon } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "assets/icons/logo.svg";
import BackgroundPatternImage from "assets/images/background-pattern.png";

import SidebarMenu from "./SidebarMenu";

const backgroundPatternOverlay = {
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${BackgroundPatternImage})`,
    backgroundPosition: "center center",
    backgroundRepeat: "repeat",
    opacity: 0.02,
    pointerEvents: "none",
  },
} as const;

const MobileSidebar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          borderRadius: 2,
          mb: 2,
          py: 2,
          pl: 3,
          pr: 2,
          bgcolor: (t: any) =>
            t.palette.brandBackground?.secondary ?? "#264B9F",
          ...backgroundPatternOverlay,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <Stack
          component={Link}
          to="/credit-evaluations"
          direction="row"
          alignItems="center"
          sx={{ textDecoration: "none" }}
        >
          <Box
            component="img"
            alt="Logo"
            src={logo}
            sx={{
              height: 28,
              width: "auto",
              objectFit: "contain",
              filter: "brightness(0) invert(1)",
            }}
          />
        </Stack>
        <IconButton
          onClick={() => setDrawerOpen(true)}
          sx={{ color: "#fff" }}
          aria-label="Open menu"
        >
          <MenuIcon />
        </IconButton>
      </Stack>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        variant="temporary"
        PaperProps={{
          sx: {
            width: 247,
            bgcolor: (t: any) =>
              t.palette.brandBackground?.secondary ?? "#264B9F",
            border: "none",
            ...backgroundPatternOverlay,
          },
        }}
      >
        <SidebarMenu onClose={() => setDrawerOpen(false)} />
      </Drawer>
    </>
  );
};

export default MobileSidebar;
